import { UserAlertLog } from '../proto/generated/nexus'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface AlertLogsStateType {
    logs: UserAlertLog[],
    recentFiredAlerts: string[]
}

const initialState: AlertLogsStateType = {
    logs: [],
    recentFiredAlerts: []
}
const alertLogsSlice = createSlice({
    name: 'alertLogs',
    initialState,
    reducers: {
        setUserAlertLogs(state: AlertLogsStateType, action: PayloadAction<UserAlertLog[]>) {
            return {
                ...state,
                logs: action.payload
            }
        },
        addFiredAlertLog(state: AlertLogsStateType, action: PayloadAction<UserAlertLog>) {
            const alertLog = action.payload;
            let logs = [...state.logs]
            let recentFiredAlerts = [...state.recentFiredAlerts]
            if (!logs.find(v => v.id === alertLog.id)) {
                logs = [alertLog, ...logs]
            }

            if (!recentFiredAlerts.find(v => v === alertLog.id)) {
                recentFiredAlerts = [...recentFiredAlerts, alertLog.id];
            }
            return {
                logs,
                recentFiredAlerts
            }
        },
        removeFiredAlert(state: AlertLogsStateType, action: PayloadAction<string>) {
            const logId = action.payload;
            return {
                ...state,
                recentFiredAlerts: state.recentFiredAlerts.filter(v => v !== logId)
            }
        },
        removeAllFiredAlerts(state: AlertLogsStateType) {
            return {
                ...state,
                recentFiredAlerts: []
            }
        },
        removeAlertLog(state: AlertLogsStateType, action: PayloadAction<string>) {
            const logId = action.payload;
            return {
                logs: state.logs.filter(v => v.id !== logId),
                recentFiredAlerts: state.recentFiredAlerts.filter(v => v !== logId)
            }
        }
    }
})

const { actions, reducer } = alertLogsSlice

export const { setUserAlertLogs, addFiredAlertLog, removeFiredAlert, removeAlertLog, removeAllFiredAlerts } = actions

export default reducer